var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"_base-count-down"},[(_vm.days)?_c('span',[_vm._v(_vm._s(_vm.days)+"天")]):_vm._e(),(_vm.hours)?_c('span',[_vm._v(_vm._s(_vm.hours)+":")]):_vm._e(),(_vm.mins)?_c('span',[_vm._v(_vm._s(_vm.mins)+":")]):_vm._e(),(_vm.seconds)?_c('span',[_vm._v(_vm._s(_vm.seconds))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }